import React from 'react';
import { Spinner } from 'react-bootstrap';

export function CenteredSpinner(props: {}) {
    return (<div className="d-flex bd-highlight mb-3">
        <div className='mx-auto'>
        <Spinner />
        </div>
    </div>);
}
